import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NumberInput.html?raw';
import lang from 'dojo/_base/lang';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import dojoNumber from 'dojo/number';
import docu from './NumberInputDocumentation.html?raw';
import { AccessibilityLabelsHelper } from "../../../more/Helpers";
import Calculator from './Calculator/Calculator';


type NumberType = "decimal" | "currency" | "percent";
class NumberInput extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: HTMLInputElement;
    fakeInputNode: HTMLInputElement;
    inputNodeContainer: HTMLInputElement;
    unit_node: HTMLElement;
    errorMsgNode: HTMLSpanElement;
    minRange: number;
    maxRange: number;
    currencySymbol: string = "€";
    //formatPrefix: string = "";
    //formatSuffix: string = "";
    //decimals: number = 0;
    //minDigits: number = 0;

    validationMsgNodeContainer = "errorMsgNode";

    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;


    protected defaultValue: string;
    protected autofocus: boolean = false;
    protected unit: string = null;//"m<sup>2</sup>"; 
    protected step: string;

    protected numberType = "decimal";
    protected restrictToAbsoluteValues: boolean = true; // the number can not be ngeative if true;
    protected reverseSign: boolean = false; // Vorzeichen des eingebenen vs. ausgegebenen Wertes umdrehen (zb für Kosteneingaben)
    //protected displayAsAbsoluteValue: boolean | "negativeOnly" = true; // todo/idee: Schalter, um das Vorzeichen anzuzeigen oder eben nicht
    protected isNegativeValue: boolean = false;
    protected locale: "de" | "en" = "de";
    protected fractional: boolean = false;
    protected places: number = 0; // wieviele Nachkommastellen ?

    protected isKeyUpActive: boolean = false;
    validationEnabled = true;

    private btnCalculator: HTMLElement;
    private enableCalculator: boolean = false;
    //validationMsgNodeContainer: string = "numberInputUnit_node";
    //Methods

    focus() {
        // this.inputNode.focus(); // müsste beides gehen..
        this.fakeInputNode.focus();
    }
    //Property getters und setters
    private _setShowCalculatorAttr(bool: boolean) {
        this.setShowCalculator(bool);
    }
    setShowCalculator(bool: boolean): void {

        this.enableCalculator = bool === true;

        this.hideNode(this.btnCalculator, !this.enableCalculator);
    }
    private _setMaxValueAttr(maxNum: number) {
        this.setMaxRange(maxNum);
    }
    private _setMaxRangeAttr(maxNum: number) {
        this.setMaxRange(maxNum);
    }
    private _setMaxAttr(maxNum: number) {

        this.setMaxRange(maxNum);
    }
    setMaxRange(maxNum: number): void {

        this.setRange(this.minRange, maxNum);
    }
    private _setMinValueAttr(minNum: number) {
        this.setMinRange(minNum);
    }
    private _setMinRangeAttr(minNum: number) {
        this.setMinRange(minNum);
    }
    private _setMinAttr(minNum: number) {
        this.setMinRange(minNum);
    }

    setMinRange(minNum: number): void {
        this.setRange(minNum, this.maxRange);
    }
    setRange(minNum: number, maxNum: number) {
        let bHasChanged = false;

        if (minNum != this.minRange) {
            bHasChanged = true;
            this.minRange = minNum;

            if (typeof (minNum) == "number") {
                this.inputNode.min = minNum.toString();
            } else {
                this.inputNode.min = "";
            }
        }

        if (maxNum != this.maxRange) {
            bHasChanged = true;

            this.maxRange = maxNum;

            if (typeof (maxNum) == "number") {
                this.UiModder.domAttr.set(this.inputNode, "max", maxNum);
            } else {
                this.inputNode.max = "";
            }
        }

        if (typeof this.maxRange == "number" || typeof this.minRange == "number") {
            this.__rangeValidation = true;
        } else {
            this.__rangeValidation = false;
        }

        this.setValidationEnabled(this.__otherValidation);

        if (bHasChanged && !this.isReadonly) {
            this.validateInput();
        }
    }

    setValidationEnabled(bEnable?: boolean) {
        this.__otherValidation = bEnable !== false;

        //let self: any = this;
        //self.inherited(arguments);

        // muss leider aus zwei Flags in das Hauptflag gerechnet werden, sonst führt Statefulbase die customValidation überhaupt nicht aus
        this.validationEnabled = this.__otherValidation || this.__rangeValidation;

        this.validateInput();

        if (this.validationEnabled != true) {
            this._setValidationResultStyle();
        }
    }

    private _setDecimalsAttr(decimals: number) {
        this.setPlaces(decimals);
    }

    //private _setPrefixAttr(prefix: string) {
    //    this.setFormat(this.decimals, prefix, this.formatSuffix, this.locale);
    //}

    //private _setSuffixAttr(suffix: string) {
    //    this.setFormat(this.decimals, this.formatPrefix, suffix, this.locale);
    //}

    //setFormat(decimals: number = 0, prefix?: string, suffix?: string, locale?: "de" | "en") {
    //    this.decimals = decimals;
    //    if (prefix) this.formatPrefix = prefix;
    //    if (suffix) this.formatSuffix = suffix;
    //    if (locale) this.locale = locale;

    //    this.formatFakeValue();
    //}

    setValue(value: any, bSuppressChangeEvent?: boolean) {

        if (typeof (value) == "number") {
            if (value < 0) this.isNegativeValue = true;
            if (this.restrictToAbsoluteValues) {
                value = Math.abs(value);
            }

            if (this.reverseSign) {
                value = -1 * value;
            }
        }
        super.setValue.apply(this, arguments as any);


        this.formatFakeValue();
    }

    private formatFakeValue() {
        let currentValue: number = this.getDirtyValue();

        //if (this.reverseSign && typeof currentValue == "number") currentValue = currentValue * -1;

        if (typeof currentValue == "number" && !(this.numberType == "percent")) {
            let txtValue = this.formatToString(currentValue);// currentValue.toString();
            //if (this.decimals) {
            //    txtValue = currentValue.toFixed(this.decimals);
            //}
            this.fakeInputNode.value =/* this.formatPrefix + */txtValue /*+ this.formatSuffix*/;
        } else if (this.numberType == "percent" && typeof currentValue == "number") {
            let txtValuePercent = this.formatToString(currentValue / 100);
            this.fakeInputNode.value =/* this.formatPrefix + */txtValuePercent /*+ this.formatSuffix*/;
        }
        else {
            this.fakeInputNode.value = "";
        }
    }
    private __rangeValidation: boolean = false;
    private __otherValidation: boolean = false;
    private _checkValueRange(value: number): boolean {

        let result = true;

        if ((this.minRange == null && this.maxRange == null) || (typeof (this.minRange) == "undefined" && typeof (this.maxRange) == "undefined")) return result;

        if (typeof value != "number") {
            return !this.isMandatory;
        }

        if (typeof (this.minRange) == "number" && value < this.minRange) {
            result = false;
        }
        if (typeof (this.maxRange) == "number" && value > this.maxRange) {
            result = false
        }

        this.validationErrorMsgText = null;

        this.__rangeValidation = typeof this.minRange == "number" || typeof this.maxRange == "number";

        if (this.minRange != null && this.maxRange != null) {
            this.validationErrorMsgText = this.stringFormat(this.translations["moreCore_NumberInput__EnterRange"], this.minRange, this.maxRange);
        } else if (this.minRange != null) {
            this.validationErrorMsgText = this.stringFormat(this.translations["moreCore_NumberInput__EnterMin"], this.minRange);
        } else if (this.maxRange != null) {
            this.validationErrorMsgText = this.stringFormat(this.translations["moreCore_NumberInput__EnterMax"], this.maxRange);
        } else {
            //this.validationErrorMsgText = this.translations["Generic__invalid_input"];
        }

        return result;
    }

    protected _setReadonlyStyle(): void {

        this.disableNode(this.btnCalculator, this.isReadonly === true);

        if (this.isReadonly === true) {
            this.UiModder.domStyle.set(this.inputNode, "opacity", 0); // muss sich unbedingt ganz ausblenden, sonst sieht man durch die Transparenz beides
            this.UiModder.domAttr.set(this.inputNode, "disabled", true);
            this.UiModder.domAttr.set(this.fakeInputNode, "disabled", true);


        } else {
            this.UiModder.domStyle.set(this.inputNode, "opacity", "");
            this.UiModder.domAttr.remove(this.inputNode, "disabled");
            this.UiModder.domAttr.remove(this.fakeInputNode, "disabled");
        }
        if (this.unit_node) {
            this.disableNode(this.unit_node, this.isReadonly === true);
        }
        if (this.labelNode) {
            //this.UiModder.domClass.toggle(this.labelNode, "w3-disabled", this.isReadonly);
        }
        this.disableNode(this.btnCalculator, this.isReadonly === true)
    }

    private _setAbsoluteAttr(value: boolean): void {

        this.setRestrictToAbsoluteValue(value);
    }
    setRestrictToAbsoluteValue(value: boolean): void {
        if (this.restrictToAbsoluteValues != value) {
            this.restrictToAbsoluteValues = value;
            this.setValue(this._value);
        }
    }

    /**
     * Dreht das Vorzeichen des Ausgabewertes um.
     * D.h. es wird 699 eingegeben, aber getValue liefert -699 und umgekehrt.
     * ACHTUNG: bei SetValue daran denken, dass der Wert invertiert übergeben werden muss!
     * @param bReverse
     */
    setReverseValueSign(bReverse: boolean) {
        this.reverseSign = bReverse == true;
    }

    setDefaultValue(value: string): void {
        this.defaultValue = value;
        this.inputNode.defaultValue = value;
    }

    getDefaultValue(): string {
        return this.defaultValue;
    }

    private _setPlacesAttr(decimals: number) {
        this.setPlaces(decimals);
    }
    setPlaces(places: number): void {
        if (places < 0 || !places) places = 0;
        this.places = places;
        this.fractional = this.places > 0;

        let steps = "";
        if (this.places >= 1) {
            steps = "1";
            for (let i = 1; i < this.places; i++) {
                steps = "0" + steps;
            }

            steps = "0." + steps;
        } else if (this.places == 0) {
            steps = "1";
        }

        if (steps != "" && this.step != steps) {
            this.setStep(steps);
        }

        this.formatFakeValue();

        //this.setStep()
    }

    getPlaces(): number {
        return this.places;
    }

    setLocale(locale: "de" | "en"): void {
        this.locale = locale;
    }

    getLocale(): string {
        return this.locale;
    }


    setAutofocus(autofocus: boolean): void {
        this.autofocus = autofocus;
        this.inputNode.autofocus = autofocus;
    }

    getAutofcus(): boolean {
        return this.autofocus;
    }

    private _setUnitAttr(unit: string): void {

        this.setUnit(unit);
    }

    setUnit(unit: string): void {
        this.unit = unit;
        this.hideNode(this.unit_node, !unit);
        this.UiModder.domAttr.set(this.unit_node, "innerHTML", this.unit)
        this.UiModder.domClass.toggle(this.unit_node, "innerHTML", this.unit != "" && this.unit != null)
    }

    getUnit(): string {
        return this.unit;
    }

    setStep(step: string | number): void {
        if (typeof (step) == "number") {
            step = step.toString();
        }

        if (!step) step = "1";
        this.step = step;
        this.UiModder.domAttr.set(this.inputNode, "step", step);
        this.inputNode.step = step;

        try {
            let counter = 0;
            let stepNumber = parseFloat(step);
            while (stepNumber < 1) {
                stepNumber = stepNumber * 10;
                counter++;

                if (counter > 99) return;
            }
            if (this.places != counter) {
                this.setPlaces(counter);
            }

        } catch (ex) {
            console.error(this.id + " setsteps failed", ex);
        }
    }

    getStep(): string {
        return this.step;
    }

    private _setStepAttr(step: string | number): void {
        this.setStep(step)
    }
    private _setNumberTypeAttr(numberType: string) {
        this.setNumberType(numberType as any);
    }
    setNumberType(numberType: NumberType): void {

        if (numberType == "decimal" || numberType == "currency" || numberType == "percent") {
            this.numberType = numberType;
            if (numberType == "currency") {
                this.setPlaces(2);
                //this.setStep("0.01");
                this.setUnit(this.currencySymbol);
            }
        } else {
            console.warn('please specify the correct type for dojo/number.NumberParseOptions, which is "decimal", "currency", or "percent". The numberType value is now "decimal".')
            this.numberType = "decimal";
        }
    }

    enableKeyUpEvent(enable: boolean): void {

        this.isKeyUpActive = enable;
    }

    // Validation_onChange_InputNode
    protected customValidation(): boolean {
        let result = true;

        let value = this._value as number;

        if (this.isMandatory) {
            if ((value == null || typeof (value) == "undefined" || typeof (value) != "number" || isNaN(value)) && this.isMandatory) {
                return false;
            }
        }

        // auch wenn nicht MANDATORY, muss die Range passen        
        result = this._checkValueRange(value);

        //console.debug("numberinput validation", result, this.validationErrorMsgText);

        return result;
    }

    // check if number is  Float
    isFloat(n: number): boolean {
        if (typeof (n) == "number") {
            let bResult = n % 1 !== 0;
            return bResult
        }
        return false;
    }

    // Value

    getDirtyValue(): number {
        let value: number;
        let number: number;
        if (this.inputNode.value) {
            number = Number(this.inputNode.value);
            this.isNegativeValue = false;
            if (!isNaN(number)) this.isNegativeValue = number < 0;

            if (this.restrictToAbsoluteValues == true) number = Math.abs(number);
            //else if (this.restrictToAbsoluteValues == "negativeOnly") number = -1 * Math.abs(number);
        }

        if (!isNaN(number) && this.isFloat(number) && typeof (number) == "number") {
            value = dojoNumber.round(number, this.places);
            return value;
        } else {
            return number;
        }
    }

    getValue(): number {
        let val = super.getValue.apply(this, arguments as any);
        if (typeof (val) == "number") {
            if (this.reverseSign) val = -1 * val;
        }

        return val;
    }

    protected setInputValue(newValue: any, suppressChangeEvent: boolean = false): void {
        this.inputNode.value = this._value;

        if (suppressChangeEvent === false) this.__delayValueChangeEmit();
    }

    formatToString(number: number): string {

        if (isNaN(number)) {
            return "";
        }

        let nString = dojoNumber.format(number, {
            type: this.numberType,
            places: this.places,
            locale: this.locale,
            fractional: this.fractional
        });

        return nString;
    }

    protected _setValidationResultStyle(): void {
        super._setValidationResultStyle.apply(this, arguments as any);

        var bHighlight = false;
        if (this._manualHighlightOverride != true) {
            bHighlight = this.highlightOnEmptyValue == true && (this.getValue() == null || this.getValue() == null);

            bHighlight = bHighlight || (this.validationEnabled == true && this.isValid != true);
        } else {
            bHighlight = this._manualHighlightOverride;
        }

        //console.debug("Numberinput _setValidationResultStyle - highlight edit manual?", this._manualHighlightOverride, bHighlight);
        //this.UiModder.domClass.toggle(this.labelNode, "w3-text-red", bHighlight);
        //this.UiModder.domClass.toggle(this.inputNode, "w3-border-red w3-pale-red", bHighlight);
        //this.UiModder.domClass.toggle(this.fakeInputNode, "w3-border-red w3-pale-red", bHighlight);

    }



    // Events
    protected _onChange_InputNode(evt?: Event): void {
        let value = this.getDirtyValue();

        if (this.reverseSign && typeof value == "number") value = value * -1;

        this.setValue(value);
    }

    protected _onFocus_FakeInput(evt?: Event) {
        this.inputNode.focus();
        this._onFocus(evt);
        //this._onFocus_Input(evt);
    }

    protected _onBlur_FakeInput(evt?: Event) {
    }

    protected _onFocus(evt?: Event) {
        this.hideNode(this.fakeInputNode);
        this.hideNode(this.inputNode, false, false);

        this.inputNode.select();
        super._onFocus.apply(this, arguments as any);
    }
    protected _onBlur_InputNode(evt?: Event) {

        let value = this.getDirtyValue();

        if (value != this._value) {
            this._onChange_InputNode();
        }

        this._onBlur(evt);

        this.hideNode(this.fakeInputNode, false);
        this.hideNode(this.inputNode, false, true);
    }



    protected _onKeyDown_InputNode(evt?: KeyboardEvent): void {

        if (evt?.key) {
            
            switch (evt.key) {

                case "+":
                case "-":
                case "*":
                case "x":
                case "/":
                    if (this.enableCalculator) {
                        this._showCalculator(false, false, evt);
                        evt.stopPropagation();
                        evt.preventDefault();
                    }
                    break;
            }
        }
    }

    protected _onKeyUp_InputNode(evt?: Event): void {

        if (this.isKeyUpActive === true) {

            this._onChange_InputNode(evt);
        }
        //this._onChange_InputNode(evt);

        this.emit("keyUp", evt);
    }
    private _onCalculatorClose(calc: MdsLax<InstanceType<typeof Calculator>>) {
        this.disableNode(this.inputNodeContainer, false);
    }
    private _onCalculatorValue(calc: MdsLax<InstanceType<typeof Calculator>>) {

        let value = calc.getValue();
        if (this.reverseSign && typeof (value) == "number") value = value * -1;
        this.setValue(value);

    }
    private _onCalculatorClick(evt: MouseEvent) {
        
        if (this._showCalculator(false, false, evt) == true) {
            evt.stopPropagation();
            evt.preventDefault();
        } else {

        }
    }

    private _showCalculator(bOverrideIfNotEnabled: boolean = false, bOverrideReadonly: boolean = false, evt?: Event): boolean {
        if (this.isReadonly === true && bOverrideReadonly !== true) return false;

      

        let calc = new Calculator();
        let container = this.UiModder.domConstruct.create("div");
        //let floating = new FloatingContainer();
        //floating.openSimple({
        //    evtSource: evt ? evt : this.domNode,
        //    alternativeTarget: this.domNode,
        //    content: container,
        //    permanent: true

        //})

        //calc.show("contentBasedDlg", this.translate("NumberInput_Calc_Label_Header"));
        //calc.show("node", container);
        
        let key = null;

        if (evt) {
            let keyEvent = evt as KeyboardEvent;
            key = keyEvent.key;
        }
        this.disableNode(this.inputNodeContainer, true);
        calc.show("floatingContainer", this.domNode);
        let value: number = this.getValue();
        if (typeof value != "number") value = 0;
        if (this.reverseSign === true) {
            calc.setValue(value * -1, key);
        } else {
            calc.setValue(value, key);
        }
        
//        calc.on("calculatorValue", lang.hitch(this, this.takeValueFromCalculator));
        calc.on("calculatorValue", lang.hitch(this, this._onCalculatorValue, calc));
        calc.on("closed", lang.hitch(this, this._onCalculatorClose));

        return true;
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // dojo

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

    }

    public setAllDataCyAttributes() {
        super.setAllDataCyAttributes.apply(this, arguments as any);
        this.setDataCyAttribute(this.fakeInputNode, "fakeInput");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.unit) {
            this.UiModder.domAttr.set(this.unit_node, "innerHTML", this.unit)
        }

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "numberInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(NumberInput);
